// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"55c5b29f","498":"f0080c76","703":"680facce","787":"0f4670b3"}[chunkId] + ".chunk.js";
};